import { Injectable } from "@angular/core";
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { Subscription } from 'rxjs/Subscription';
import { timer } from 'rxjs/observable/timer';

import { environment } from "../../environments/environment";

@Injectable()
export class SessionTimeoutService {
  private timer: Observable<number> = null;
  private timerSubscription: Subscription = null;
  public readonly sessionTimedOut: Subject<undefined> = new Subject<undefined>();

  get isActive(): boolean {
    return this.timer && this.timerSubscription ? true : false;
  }

  startTimer(): void {
    if (!this.isActive) {
      this.timer = timer(environment.sessionTimeoutInSeconds * 1000);
      this.timerSubscription = this.timer.subscribe((): void => {
        this.stopTimer();
        this.sessionTimedOut.next();
      });
    }
  }

  stopTimer(): void {
    if (this.timerSubscription) {
      this.timerSubscription.unsubscribe();
      this.timerSubscription = null;
    }
    this.timer = null;
  }

  resetTimer(): void {
    if (this.isActive) {
      this.stopTimer();
      this.startTimer();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/_services/session-timeout.service.ts